import styles from "./index.module.scss";

const TableHeader = () => {
  return (
    <div className={styles.table_head}>
      {Array(12)
        .fill(0)
        .map((_, idx) => {
          if (idx === 0) {
            return <div className={styles.table_head_category} key={idx} />;
          }
          return (
            <div className={styles.table_head_cell} key={idx}>{`Renewal ${
              idx - 1
            }`}</div>
          );
        })}
    </div>
  );
};

export default TableHeader;
